import React from "react";

const formatDuration = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;

  return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
};

export default function SaveContactScreen({
  dialValue,
  duration,
  notes,
  contactName,
  onContactNameChange,
  onSaveContact,
  isSavingContact,
  contactFeedback,
  onReturnToReady,
}) {
  return (
    <section className="dialer-save-screen">
      <div className="dialer-save-topbar">
        <button
          type="button"
          className="dialer-secondary-button dialer-save-back-button"
          onClick={onReturnToReady}
        >
          Back To Dialer
        </button>
      </div>

      <div className="dialer-save-header">
        <div className="dialer-section-label">Ended state</div>
        <h2 className="dialer-section-title">Save Contact Screen</h2>
      </div>

      <div className="dialer-save-body">
        <div className="dialer-save-summary">
          <div>
            <span className="dialer-save-stat-label">Number</span>
            <div className="dialer-save-stat-value">
              {dialValue || "No number captured"}
            </div>
          </div>
          <div>
            <span className="dialer-save-stat-label">Duration</span>
            <div className="dialer-save-stat-value">{formatDuration(duration)}</div>
          </div>
        </div>

        <div className="dialer-save-form">
          <div>
            <label htmlFor="save-contact-name" className="dialer-form-label">
              Contact Name
            </label>
            <input
              id="save-contact-name"
              type="text"
              className="dialer-input"
              placeholder="Add a contact name"
              value={contactName}
              onChange={(event) => onContactNameChange(event.target.value)}
            />
          </div>

          <div className="dialer-save-form-full">
            <label htmlFor="save-contact-notes" className="dialer-form-label">
              Last Call Notes
            </label>
            <textarea
              id="save-contact-notes"
              className="dialer-textarea"
              value={notes}
              readOnly
            />
          </div>
        </div>

        {contactFeedback ? (
          <div className="dialer-inline-feedback">{contactFeedback}</div>
        ) : null}
      </div>

      <div className="dialer-save-actions">
        <button
          type="button"
          className="dialer-primary-button"
          onClick={onSaveContact}
          disabled={isSavingContact || !contactName.trim()}
        >
          {isSavingContact ? "Saving..." : "Save Contact"}
        </button>
      </div>
    </section>
  );
}
